import SaleUtils from '@/services/SaleUtils'
import { required } from '@/services/validations'
/* models */
import WhUnitMeasurement from '@/models/Warehouse/WhUnitOfMeasurement'
import ProductStockHeaders from './headers'
import BranchOfficeModel from '@/models/General/GBranchOffice'
// Fields to Comercial Information
export default [
    {
        props: { title: 'Stock Global' },
        type: 'section-field',
        flex: {
            'mb-3': true,
            xs12: true,
        },
    },
    {
        name: 'minimum_stock',
        type: 'currency-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Mínimo stock',
            suffix: '',
            //rules: [integer],
        },
        trigger: ctx => {
            //alert('minimum')
            ctx.value.branch_office_selected.map(branch => {
                console.log(branch, 'branch')
                if (ctx.value.minimum_stock) {
                    branch.minimum_stock = ctx.value.minimum_stock
                }
                // if(ctx.value.maximum_stock){
                //   branch.maximum_stock = ctx.value.maximum_stock
                // }
                // if(ctx.value.critical_stock){
                //   branch.critical_stock = ctx.value.critical_stock
                // }
            })
        },
    },
    {
        name: 'maximum_stock',
        type: 'currency-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Maximo stock',
            suffix: ''
            //rules: [required],
        },
        trigger: ctx => {
            ctx.value.branch_office_selected.map(branch => {
                // if(ctx.value.minimum_stock){
                //   branch.minimum_stock = ctx.value.minimum_stock
                // }
                if (ctx.value.maximum_stock) {
                    branch.maximum_stock = ctx.value.maximum_stock
                }
                // if(ctx.value.critical_stock){
                //   branch.critical_stock = ctx.value.critical_stock
                // }
            })
        },
    },
    {
        name: 'critical_stock',
        type: 'currency-field',
        props: {
            label: 'Stock critico',
        },
        trigger: ctx => {
            ctx.value.branch_office_selected.map(branch => {
                // if(ctx.value.minimum_stock){
                //   branch.minimum_stock = ctx.value.minimum_stock
                // }
                // if(ctx.value.maximum_stock){
                //   branch.maximum_stock = ctx.value.maximum_stock
                // }
                if (ctx.value.critical_stock) {
                    branch.critical_stock = ctx.value.critical_stock
                }
            })
        },
        rules: [],
        // computed: ({ sale_price }) => {
        //     return '$' + SaleUtils.getNetPrice(sale_price)
        // },
    },
    {
        props: { title: 'Stock por Oficinas' },
        type: 'section-field',
        flex: {
            'mb-3': true,
            xs12: true,
        },
    },
    {
        name: 'branch_office_selected',
        type: 'data-table-model',
        flex: {
            'pt-0': true,
            xs12: true,
        },
        props: {
            checkable: true,
            class: 'v-card elevation-2 mb-4',
            headers: ProductStockHeaders,
            noActions: true,
            noDataText: 'Sin sucursales.',
            noFilter: true,
            noExport: true,
            noHelper: true,
            noPagination: true,
            noSearch: true,

            showNativePagination: true,
            //showPicker: true,
            style: {
                //margin: "0 -24px"
            },
            toolbarTitle: 'Detalle del stock en las diferentes sucursales',
            toolbarColor: 'primary',
            toolbarDark: true,
            toolbarDense: true,
        },
    },
    
    
    {
        props: { title: '' },
        type: 'section-field',
        flex: {
            xs12: true,
        },
    },
    {
        name: 'is_repackaged',
        type: 'checkbox',
        props: {
            label: 'Producto Envasado',
        },
        value: false,
    },
    
    {
        name: 'is_seasonal',
        type: 'checkbox',
        props: {
            label: 'Producto Temporada',
            'false-value': false,
        },
        value: false,
    },
]
